import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { PainPoints } from './components/PainPoints';
import { Journey } from './components/Journey';
import { Bands } from './components/Bands';
import { Practice } from './components/Practice';
import { HowItWorks } from './components/HowItWorks';
import { UseCases } from './components/UseCases';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { ClosingCta } from './components/ClosingCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '1963243531011867';
const PAGE_TITLE = 'KINDERHANDBALL – Mit Plan ins Training | 6 PDF-Bände für 6–12 Jahre';
const PAGE_DESCRIPTION = 'Digitale Praxis-Sammlung für Lehrkräfte und Trainerinnen und Trainer: sechs PDF-Bände mit 360 Seiten Trainingseinheiten für Kinderhandball von 6 bis 12 Jahren.';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  useEffect(() => {
    document.documentElement.lang = 'de';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);
  return <div className="w-full bg-navy-800 font-sans" data-id="element-0" data-mp="33m5c656pjo8v">
      <Hero data-id="element-1" data-mp="33myjb79kwfrj" />
      <main data-id="element-2" data-mp="33oi1j3esp0vy">
        <StatsStrip data-id="element-3" data-mp="38lrs4mdx7ild" />
        <PainPoints data-id="element-4" data-mp="38li8rhnds9on" />
        <Journey data-id="element-5" data-mp="38l05i12awv78" />
        <Bands data-id="element-6" data-mp="38kgmeh0x00rm" />
        <Practice data-id="element-7" data-mp="38o4gpie6or7e" />
        <HowItWorks data-id="element-8" data-mp="3dkl58dpap7l0" />
        <UseCases data-id="element-9" data-mp="3dl4ktnrh3jvv" />
        <Bonuses data-id="element-10" data-mp="3dlnwimqj5c1g" />
        <Offer data-id="element-11" data-mp="3dm5vhr4ku4d2" />
        <Faq data-id="element-12" data-mp="3dii5v329623m" />
        <ClosingCta data-id="element-13" data-mp="nvsv37yeytxj" />
      </main>
      <Footer data-id="element-14" data-mp="nuhiqjqwkdut" />
      <StickyCta data-id="element-15" data-mp="nv0xjrl9am4m" />
    </div>;
}